/* OXXRING v2 size tools — shared size-reference core + the size charts hub.
   Core: window.OXXIC_SIZEREF (also window.OXXIC.sizeref), used by oxx-ic-xref.js.
   Data: assets/oxx-ic-sizeref.json (nominal ID/CS from public size references, reference tolerances) and the
   live catalog size index (grades listed at a nominal size). No OD is read, stored or shown. */
(function () {
  'use strict';
  var MM = 25.4;
  var EPS = 0.006;
  var CLOSE_ID = 2.5, CLOSE_CS = 2;

  function num(v) { var n = parseFloat(String(v == null ? '' : v).replace(',', '.')); return isNaN(n) ? NaN : n; }
  function fmtMm(v) { return (Math.round(v * 100 + 1e-9) / 100).toFixed(2); }
  function fmtIn(v) { return (Math.round(v * 1000 + 1e-9) / 1000).toFixed(3); }
  function trim0(v) { return String(Math.round(v * 100) / 100); }
  /* tolerance bands: [[maxValue, tol], ...] ascending */
  function band(list, v) {
    if (!list || !list.length) return 0;
    for (var i = 0; i < list.length; i++) if (v <= list[i][0] + 0.005) return list[i][1];
    return list[list.length - 1][1];
  }

  var SYSTEMS = [
    { key: 'as568', label: 'AS568', noun: 'AS568', std: 'AS568' },
    { key: 'bs1806', label: 'BS 1806', noun: 'BS 1806', std: 'BS1806' },
    { key: 'jis', label: 'JIS B 2401', noun: 'JIS B 2401', std: 'JIS2401' },
    { key: 'metric', label: 'Metric', noun: 'metric', std: '' }
  ];
  var SYS = {};
  SYSTEMS.forEach(function (s) { SYS[s.key] = s; });
  var MAT_LETTER = { NBR: 'N', FKM: 'F', FFKM: 'K', EPDM: 'E', SILICONE: 'S', VMQ: 'S' };

  var core = {
    MM: MM, EPS: EPS, systems: SYSTEMS, rows: {}, tol: { id: [], cs: [] },
    index: { rows: [], x: {} }, listed: new Map(), indexed: false,
    num: num, fmtMm: fmtMm, fmtIn: fmtIn, trim0: trim0, matLetter: MAT_LETTER,
    sys: function (k) { return SYS[k]; },

    build: function (data) {
      core.tol.id = (data.tol && data.tol.id) || [];
      core.tol.cs = (data.tol && data.tol.cs) || [];
      var inch = function (v) { return Math.round(v / MM * 10000) / 10000; };
      core.rows.as568 = (data.as568 || []).map(function (r) {
        return { k: 'as568', raw: r[0], id: r[1], cs: r[2], i: r[3], s: r[4], ti: r[5] ? r[5] * MM : null, ts: r[6] ? r[6] * MM : null, tiIn: r[5] || null, tsIn: r[6] || null, g: r[0].charAt(0) };
      });
      core.rows.bs1806 = (data.bs1806 || []).map(function (r) {
        return { k: 'bs1806', raw: r[0], id: r[1], cs: r[2], i: r[3], s: r[4], g: r[0].charAt(0) };
      });
      core.rows.jis = (data.jis || []).map(function (r) {
        return { k: 'jis', raw: r[0], id: r[1], cs: r[2], i: inch(r[1]), s: inch(r[2]), g: (r[0].match(/^[A-Z]+/) || [''])[0] };
      });
      core.rows.metric = (data.metric || []).map(function (r) {
        return { k: 'metric', raw: '', id: r[0], cs: r[1], i: inch(r[0]), s: inch(r[1]), g: fmtMm(r[1]) };
      });
      core.ready = true;
      return core;
    },
    setIndex: function (index) {
      core.index = index && index.rows ? index : { rows: [], x: {} };
      core.listed = new Map();
      core.index.rows.forEach(function (r) { core.listed.set(fmtMm(r.id) + ',' + fmtMm(r.cs), r); });
      core.indexed = core.index.rows.length > 0;
      return core;
    },
    load: function (refUrl) {
      if (!core.refPromise) core.refPromise = window.OXXIC.loadJSON(refUrl).then(core.build);
      return core.refPromise;
    },
    loadIndex: function (indexUrl) {
      if (!core.indexPromise) {
        core.indexPromise = (indexUrl && window.OXXIC && window.OXXIC.sizeIndex ? window.OXXIC.sizeIndex(indexUrl) : Promise.reject(new Error('no index')))
          .then(core.setIndex, function () { return core.setIndex(null); });
      }
      return core.indexPromise;
    },

    /* catalog: exact nominal match within 0.006 mm */
    listedAt: function (id, cs) {
      var hit = core.listed.get(fmtMm(id) + ',' + fmtMm(cs));
      if (hit && Math.abs(hit.id - id) < EPS && Math.abs(hit.cs - cs) < EPS) return hit;
      return null;
    },
    listedCount: function (id, cs) { var r = core.listedAt(id, cs); return r ? r.codes.length : 0; },
    handle: function (row, code) { return window.OXXIC.handleFor(core.index, row, code); },

    label: function (row) {
      if (row.k === 'as568') return 'AS568 -' + row.raw;
      if (row.k === 'bs1806') return 'BS 1806 ' + row.raw;
      if (row.k === 'jis') return 'JIS ' + row.raw;
      return trim0(row.id) + ' × ' + trim0(row.cs) + ' mm';
    },
    query: function (row) {
      if (row.k === 'as568') return '-' + row.raw;
      if (row.k === 'bs1806') return 'BS ' + row.raw;
      if (row.k === 'jis') return row.raw;
      return trim0(row.id) + ' x ' + trim0(row.cs);
    },
    stdParams: function (row) {
      if (row.k === 'as568') return '&standard=AS568&standard_code=-' + row.raw;
      if (row.k === 'bs1806') return '&standard=' + encodeURIComponent('BS 1806') + '&standard_code=' + encodeURIComponent(row.raw);
      if (row.k === 'jis') return '&standard=' + encodeURIComponent('JIS B 2401') + '&standard_code=' + encodeURIComponent(row.raw);
      return '';
    },
    /* the size finder resolves AS568 dash numbers itself; other systems are passed as dimensions only */
    finderStd: function (row) { return row && row.k === 'as568' ? core.stdParams(row) : ''; },

    /* reference tolerance (mm): AS568 rows use their own table, all others the general-purpose band */
    tolOf: function (row) {
      if (row.k === 'as568' && row.ti) return { id: row.ti, cs: row.ts, src: 'std' };
      return { id: band(core.tol.id, row.id), cs: band(core.tol.cs, row.cs), src: 'gp' };
    },

    /* compare a chart row with a target {id, cs, tolId, tolCs} (mm) */
    compare: function (row, t) {
      var tol = core.tolOf(row);
      var wId = Math.max(tol.id, t.tolId || 0), wCs = Math.max(tol.cs, t.tolCs || 0);
      var dId = row.id - t.id, dCs = row.cs - t.cs, aId = Math.abs(dId), aCs = Math.abs(dCs);
      var status = aId <= wId + 1e-6 && aCs <= wCs + 1e-6 ? 'same'
        : aId <= wId * CLOSE_ID + 1e-6 && aCs <= wCs * CLOSE_CS + 1e-6 ? 'nearby' : 'diff';
      return { row: row, sys: row.k, dId: dId, dCs: dCs, exact: aId < EPS && aCs < EPS, codeExact: !!(t.code && row.raw && row.raw.toUpperCase() === t.code), tol: tol, within: { id: wId, cs: wCs }, status: status, score: aId / wId + aCs / wCs };
    },
    closest: function (sysKey, t, limit) {
      var rows = core.rows[sysKey] || [], out = [];
      for (var i = 0; i < rows.length; i++) out.push(core.compare(rows[i], t));
      out.sort(function (a, b) { return (b.codeExact - a.codeExact) || (b.exact - a.exact) || a.score - b.score || Math.abs(a.dId) - Math.abs(b.dId); });
      return out.slice(0, limit || 3);
    },

    /* ---------- one-box parser ---------- */
    parse: function (text) {
      var out = { raw: String(text == null ? '' : text).trim(), kind: 'empty' };
      var s = out.raw.replace(/[−–—]/g, '-').replace(/\s+/g, ' ');
      if (!s) return out;

      var sku = s.match(/^OXX[-_ ]?OR[-_ ]?(\d+(?:[Pp.,]\d+)?)[-_ ](\d+(?:[Pp.,]\d+)?)[-_ ]([A-Za-z]+)(?:[-_ ](\d{2})\s*A?\b)?/i);
      if (sku) {
        out.kind = 'size'; out.via = 'sku'; out.units = 'mm';
        out.id = num(sku[1].replace(/[Pp]/, '.')); out.cs = num(sku[2].replace(/[Pp]/, '.'));
        out.mat = sku[3].toUpperCase(); out.hard = sku[4] || '';
        return core.checkSize(out);
      }
      if (/^OXX[-_ ]?OR/i.test(s)) { out.kind = 'sku-other'; return out; }

      var hint = null, body = s, m;
      if ((m = body.match(/^as\s*-?\s*568(?:[a-z](?![a-z]))?[\s\-_#:]*/i))) { hint = 'as568'; body = body.slice(m[0].length); }
      else if ((m = body.match(/^(?:bs|british standard)\s*-?\s*(?:(?:1806|4518)(?!\d))?[\s\-_#:]*/i))) { hint = 'bs1806'; body = body.slice(m[0].length); }
      else if ((m = body.match(/^jis\s*-?\s*(?:b\s*-?\s*2401(?!\d))?[\s\-_#:]*/i))) { hint = 'jis'; body = body.slice(m[0].length); }

      var t = body.replace(/(\d),(\d)/g, '$1.$2').replace(/(\d)\s*(?:"|''|″|inch(?:es)?\b|in\b)/gi, '$1 in ').replace(/[×✕*]/g, 'x');
      var inch = /\bin\b/i.test(t);
      var d = t.match(/(?:\bid\s*[:=]?\s*)?(\d*\.?\d+)\s*(?:mm|in)?\s*(?:x|by|\/)\s*(?:cs\s*[:=]?\s*)?(\d*\.?\d+)/i) ||
              t.match(/\bid\s*[:=]?\s*(\d*\.?\d+)\s*(?:mm|in)?[\s,;]+(?:cs|w|width|section)\s*[:=]?\s*(\d*\.?\d+)/i) ||
              t.match(/^\s*(\d*\.?\d+)\s*(?:mm|in)?\s+(\d*\.?\d+)\s*(?:mm|in)?\s*$/i);
      if (d) {
        out.kind = 'size'; out.via = 'dims'; out.units = inch ? 'in' : 'mm';
        out.id = num(d[1]); out.cs = num(d[2]);
        return core.checkSize(out);
      }

      var code = body.toUpperCase().replace(/^[-#\s]+|[\s]+$/g, '').replace(/\s+/g, '');
      if (!code) { out.kind = 'unparsed'; return out; }
      var order = hint ? [hint] : ['as568', 'bs1806', 'jis'];
      for (var i = 0; i < order.length; i++) {
        var row = core.findCode(order[i], code);
        if (row) { out.kind = 'code'; out.row = row; out.hint = hint; out.id = row.id; out.cs = row.cs; out.units = 'mm'; return out; }
      }
      out.kind = /^\d+(?:\.\d+)?$/.test(code) && !/^\d{1,3}$/.test(code) ? 'single' : 'unknown';
      out.code = code; out.hint = hint;
      return out;
    },
    checkSize: function (out) {
      if (!(out.id > 0) || !(out.cs > 0)) { out.kind = 'bad'; return out; }
      if (out.cs > out.id) { var x = out.id; out.id = out.cs; out.cs = x; out.swapped = true; }
      out.inId = out.id; out.inCs = out.cs;
      if (out.units === 'in') { out.id = out.id * MM; out.cs = out.cs * MM; }
      return out;
    },
    findCode: function (sysKey, code) {
      var rows = core.rows[sysKey] || [], want = code.replace(/^-+/, ''), i;
      if (/^\d{1,3}$/.test(want)) {
        if (sysKey === 'jis') return null;
        var pad = ('00' + want).slice(-3);
        for (i = 0; i < rows.length; i++) if (rows[i].raw === pad) return rows[i];
        return null;
      }
      for (i = 0; i < rows.length; i++) if (rows[i].raw.toUpperCase() === want) return rows[i];
      return null;
    }
  };
  window.OXXIC_SIZEREF = core;
  function attach() { if (window.OXXIC && !window.OXXIC.sizeref) window.OXXIC.sizeref = core; }
  attach();

  /* ================= size charts hub ================= */
  var PAGE = 200;

  function initCharts(root) {
    attach();
    var $ = function (s) { return root.querySelector(s); };
    var qEl = $('[data-ic-charts-q]'), seriesEl = $('[data-ic-charts-series]'), sortEl = $('[data-ic-charts-sort]');
    var listedEl = $('[data-ic-charts-listed]'), countEl = $('[data-ic-charts-count]'), gpEl = $('[data-ic-charts-legend-gp]');
    var finder = root.getAttribute('data-finder-url'), xref = root.getAttribute('data-xref-url');
    var tabs = [].slice.call(root.querySelectorAll('[data-ic-charts-tab]'));
    var panels = {}, server = {}, st = { tab: root.getAttribute('data-tab') || 'as568', q: '', series: '', sort: 'std', dir: 'asc', listed: false, shown: PAGE, idx: [], near: null };
    [].forEach.call(root.querySelectorAll('[data-ic-charts-panel]'), function (p) {
      var k = p.getAttribute('data-ic-charts-panel');
      panels[k] = { el: p, body: p.querySelector('[data-ic-charts-rows]'), more: p.querySelector('[data-ic-charts-more]'), empty: p.querySelector('[data-ic-charts-empty]') };
    });
    var params = new URLSearchParams(window.location.search);
    if (panels[params.get('chart')]) st.tab = params.get('chart');
    if (params.get('q')) st.q = params.get('q');

    function rows() { return core.rows[st.tab] || []; }
    function finderUrl(row) { return finder + '&units=mm&id=' + fmtMm(row.id) + '&cs=' + fmtMm(row.cs) + core.finderStd(row) + '&source=size-charts'; }
    function rfqUrl(row) { return '/pages/bulk-quote?source=size-charts&request_mode=CUSTOM&units=mm&id=' + fmtMm(row.id) + '&cs=' + fmtMm(row.cs) + core.stdParams(row); }
    function xrefUrl(row) { return xref + '&q=' + encodeURIComponent(core.query(row)); }
    function cat(row) {
      if (!core.indexed) return '<span class="ic-charts-cat ic-subtle">…</span>';
      var n = core.listedCount(row.id, row.cs);
      return n ? '<a class="ic-charts-cat" href="' + finderUrl(row) + '">' + n + ' grade' + (n === 1 ? '' : 's') + '</a>'
        : '<a class="ic-charts-cat ic-charts-cat--rfq" href="' + rfqUrl(row) + '">Request</a>';
    }
    function tolCell(row) {
      var t = core.tolOf(row);
      return '±' + fmtMm(t.id) + ' / ±' + fmtMm(t.cs) + '<small>' + (t.src === 'std' ? '±' + fmtIn(row.tiIn) + ' / ±' + fmtIn(row.tsIn) + ' in' : 'general') + '</small>';
    }
    function rowHtml(row, cls) {
      var name = row.k === 'bs1806' ? 'BS ' + row.raw : row.k === 'jis' ? row.raw : row.k === 'as568' ? '-' + row.raw : trim0(row.id) + ' × ' + trim0(row.cs);
      return '<tr' + (cls ? ' class="' + cls + '"' : '') + '><th scope="row"><a href="' + xrefUrl(row) + '">' + name + '</a></th>' +
        '<td>' + fmtMm(row.id) + '</td><td>' + fmtMm(row.cs) + '</td><td>' + fmtIn(row.id / MM) + '</td><td>' + fmtIn(row.cs / MM) + '</td>' +
        '<td>' + tolCell(row) + '</td><td>' + cat(row) + '</td></tr>';
    }

    /* ---------- filter ---------- */
    function parseQ(q) {
      var s = String(q || '').trim();
      if (!s) return null;
      var p = core.parse(s);
      if (p.kind === 'size') return { pair: true, id: p.id, cs: p.cs, label: fmtMm(p.id) + ' × ' + fmtMm(p.cs) + ' mm' };
      var t = s.replace(/(\d),(\d)/g, '$1.$2');
      var inch = /\d\s*(?:"|in\b|inch)/i.test(t);
      var n = (t.match(/\d*\.?\d+/) || [])[0];
      var code = s.toUpperCase().replace(/^(AS\s*-?\s*568|BS\s*-?\s*(1806)?|JIS(\s*B\s*2401)?)/, '').replace(/^[-#\s]+/, '').replace(/\s+/g, '');
      return { pair: false, code: code, v: n ? num(n) : NaN, inch: inch, digits: /^\d+$/.test(code) };
    }
    function matchOne(row, f) {
      if (f.code) {
        if (row.raw && row.raw.toUpperCase().indexOf(f.code) === 0) return true;
        if (row.k === 'jis' && f.digits && row.raw.replace(/^[A-Z]+/, '').indexOf(f.code) === 0) return true;
      }
      if (isNaN(f.v)) return false;
      if (f.inch) return Math.abs(f.v * MM - row.id) < 0.04 || Math.abs(f.v * MM - row.cs) < 0.04;
      if (Math.abs(f.v - row.id) < 0.03 || Math.abs(f.v - row.cs) < EPS) return true;
      return f.v < 20 && /\.\d{3}$/.test(String(f.v)) && (Math.abs(f.v - row.i) < 0.0006 || Math.abs(f.v - row.s) < 0.0006);
    }
    function compute() {
      var all = rows(), idx = [], i, f = parseQ(st.q);
      st.near = null; st.hits = {};
      for (i = 0; i < all.length; i++) {
        var r = all[i];
        if (st.series && (st.tab === 'jis' ? r.g !== st.series : fmtMm(r.cs) !== st.series)) continue;
        if (st.listed && core.indexed && !core.listedCount(r.id, r.cs)) continue;
        idx.push(i);
      }
      if (f && f.pair) {
        var t = { id: f.id, cs: f.cs, code: f.code || '' }, scored = idx.map(function (i) { return { i: i, c: core.compare(all[i], t) }; });
        scored.sort(function (a, b) { return (b.c.exact - a.c.exact) || a.c.score - b.c.score; });
        var good = scored.filter(function (x) { return x.c.status !== 'diff'; }).slice(0, 12);
        st.near = { label: f.label, exact: good.length > 0, n: good.length };
        (good.length ? good : scored.slice(0, 6)).forEach(function (x) { st.hits[x.i] = x.c.exact ? 'hit' : x.c.status === 'same' ? 'near' : ''; x.s = x.c.score; });
        idx = (good.length ? good : scored.slice(0, 6)).map(function (x) { return x.i; });
        if (st.sort === 'std') return (st.idx = idx);
      } else if (f && (f.code || !isNaN(f.v))) {
        idx = idx.filter(function (i) { return matchOne(all[i], f); });
        if (f.code && st.sort === 'std') {
          /* an exact code match leads, then the rest in chart order */
          idx.sort(function (a, b) { return ((all[b].raw || '').toUpperCase() === f.code) - ((all[a].raw || '').toUpperCase() === f.code) || a - b; });
          idx.forEach(function (i) { if ((all[i].raw || '').toUpperCase() === f.code) st.hits[i] = 'hit'; });
        }
      }
      var k = st.sort, dir = st.dir === 'desc' ? -1 : 1;
      if (k !== 'std' && k !== 'match') {
        idx.sort(function (a, b) {
          var A = all[a], B = all[b], v;
          if (k === 'id') v = A.id - B.id || A.cs - B.cs;
          else if (k === 'cs') v = A.cs - B.cs || A.id - B.id;
          else v = core.listedCount(B.id, B.cs) - core.listedCount(A.id, A.cs) || A.id - B.id;
          return v * dir;
        });
      }
      return (st.idx = idx);
    }

    /* ---------- paint ---------- */
    function paint(reset) {
      var P = panels[st.tab], all = rows(), idx = compute(), n = idx.length, i;
      if (reset) st.shown = PAGE;
      if (server[st.tab]) {
        /* rows stay in the HTML (search engines); on phones only the first page is shown */
        var map = server[st.tab], frag = document.createDocumentFragment(), used = {};
        var cap = window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? st.shown : n;
        for (i = 0; i < n; i++) { var tr = map[all[idx[i]].raw]; if (tr) { tr.hidden = i >= cap; tr.className = st.hits[idx[i]] ? 'ic-charts-row--' + st.hits[idx[i]] : ''; frag.appendChild(tr); used[all[idx[i]].raw] = 1; } }
        Object.keys(map).forEach(function (k) { if (!used[k]) { map[k].hidden = true; frag.appendChild(map[k]); } });
        P.body.appendChild(frag);
        P.more.hidden = cap >= n;
        if (!P.more.hidden) P.more.querySelector('button').textContent = 'Show ' + Math.min(PAGE, n - cap) + ' more of ' + (n - cap).toLocaleString('en-US');
      } else {
        var end = Math.min(n, st.shown), html = [];
        for (i = 0; i < end; i++) html.push(rowHtml(all[idx[i]], st.hits[idx[i]] ? 'ic-charts-row--' + st.hits[idx[i]] : ''));
        P.body.innerHTML = html.join('');
        P.more.hidden = end >= n;
        if (!P.more.hidden) P.more.querySelector('button').textContent = 'Show ' + Math.min(PAGE, n - end) + ' more of ' + (n - end).toLocaleString('en-US');
      }
      var name = core.sys(st.tab).noun, total = all.length.toLocaleString('en-US');
      var filtered = st.q || st.series || st.listed;
      if (st.near) {
        countEl.textContent = st.near.exact
          ? n + ' ' + name + ' size' + (n === 1 ? '' : 's') + ' at or near ' + st.near.label + ' · closest first'
          : 'No ' + name + ' size within tolerance of ' + st.near.label + ' · ' + n + ' closest shown, compare before substituting';
      } else {
        countEl.textContent = n.toLocaleString('en-US') + (filtered ? ' of ' + total : '') + ' ' + name + ' size' + (n === 1 ? '' : 's');
      }
      P.empty.hidden = n > 0;
      var rfq = P.empty.querySelector('[data-ic-charts-rfq]');
      if (rfq) rfq.href = '/pages/bulk-quote?source=size-charts&request_mode=CUSTOM' + (st.q ? '&size_or_sku=' + encodeURIComponent(st.q.slice(0, 120)) : '');
      gpEl.hidden = st.tab === 'as568' && !idx.some(function (i) { return !all[i].ti; });
      sortEl.querySelector('[value="match"]').hidden = !st.near;
    }

    function series() {
      var all = rows(), seen = {}, list = [], i, r, key;
      for (i = 0; i < all.length; i++) {
        r = all[i]; key = st.tab === 'jis' ? r.g : fmtMm(r.cs);
        if (!seen[key]) { seen[key] = { key: key, n: 0, lo: r.cs, hi: r.cs, cs: r.cs }; list.push(seen[key]); }
        seen[key].n++; seen[key].lo = Math.min(seen[key].lo, r.cs); seen[key].hi = Math.max(seen[key].hi, r.cs);
      }
      if (st.tab !== 'jis') list.sort(function (a, b) { return a.cs - b.cs; });
      seriesEl.innerHTML = '<option value="">All series</option>' + list.map(function (s) {
        var label = st.tab === 'jis'
          ? s.key + ' series · CS ' + (s.lo === s.hi ? trim0(s.lo) : trim0(s.lo) + '–' + trim0(s.hi)) + ' mm'
          : 'CS ' + s.key + ' mm' + (st.tab === 'metric' ? '' : ' · ' + fmtIn(s.cs / MM) + ' in');
        return '<option value="' + s.key + '">' + label + ' (' + s.n + ')</option>';
      }).join('');
      seriesEl.value = seen[st.series] ? st.series : '';
      st.series = seriesEl.value;
    }

    function syncUrl() {
      try {
        var u = new URL(window.location.href);
        if (st.tab !== (root.getAttribute('data-tab') || 'as568')) u.searchParams.set('chart', st.tab); else u.searchParams.delete('chart');
        if (st.q) u.searchParams.set('q', st.q); else u.searchParams.delete('q');
        window.history.replaceState({}, '', u.toString());
      } catch (e) { /* preview */ }
    }

    function setTab(tab, focus) {
      st.tab = tab; st.series = '';
      tabs.forEach(function (b) {
        var on = b.getAttribute('data-ic-charts-tab') === tab;
        b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1;
        if (on && focus) b.focus();
      });
      Object.keys(panels).forEach(function (k) { panels[k].el.hidden = k !== tab; });
      series(); paint(true); syncUrl();
    }

    function setSort(key, dir) {
      st.sort = key; st.dir = dir || 'asc';
      sortEl.value = key === 'id' && st.dir === 'desc' ? 'id-desc' : key;
      [].forEach.call(root.querySelectorAll('.ic-charts-sort'), function (b) {
        var on = b.getAttribute('data-ic-charts-sortby') === key && key !== 'std' && key !== 'match';
        if (on) b.setAttribute('data-dir', st.dir); else b.removeAttribute('data-dir');
        b.closest('th').setAttribute('aria-sort', on ? (st.dir === 'asc' ? 'ascending' : 'descending') : 'none');
      });
    }

    function onQuery() {
      var wasNear = !!st.near;
      st.q = qEl.value.trim();
      var f = parseQ(st.q);
      if (f && f.pair && st.sort === 'std') setSort('match');
      if ((!f || !f.pair) && st.sort === 'match') setSort('std');
      paint(true);
      if (wasNear !== !!st.near) syncUrl();
      syncUrl();
    }

    function boot() {
      var body = panels.as568 && panels.as568.body;
      if (body && body.querySelector('tr')) {
        server.as568 = {};
        [].forEach.call(body.querySelectorAll('tr[data-k]'), function (tr) { server.as568[tr.getAttribute('data-k')] = tr; });
      }
      var timer;
      qEl.value = st.q;
      qEl.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(onQuery, 150); });
      qEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); clearTimeout(timer); onQuery(); } });
      seriesEl.addEventListener('change', function () { st.series = seriesEl.value; paint(true); });
      sortEl.addEventListener('change', function () { var v = sortEl.value; if (v === 'id-desc') setSort('id', 'desc'); else setSort(v); paint(true); });
      listedEl.addEventListener('change', function () { st.listed = listedEl.checked; paint(true); });
      [].forEach.call(root.querySelectorAll('.ic-charts-sort'), function (b) {
        b.addEventListener('click', function () {
          var k = b.getAttribute('data-ic-charts-sortby');
          if (k === 'std') setSort(st.near ? 'match' : 'std');
          else setSort(k, st.sort === k && st.dir === 'asc' ? 'desc' : 'asc');
          paint(true);
        });
      });
      Object.keys(panels).forEach(function (k) {
        var btn = panels[k].more.querySelector('button');
        btn.addEventListener('click', function () { st.shown += PAGE; paint(false); });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && !panels[k].more.hidden && st.tab === k && st.shown < 1600 && !server[k]) { st.shown += PAGE; paint(false); } }); }, { rootMargin: '400px 0px' }).observe(panels[k].more);
        }
      });
      tabs.forEach(function (b, i) {
        b.addEventListener('click', function () { setTab(b.getAttribute('data-ic-charts-tab'), false); });
        b.addEventListener('keydown', function (e) {
          var n = tabs.length, j = e.key === 'ArrowRight' ? (i + 1) % n : e.key === 'ArrowLeft' ? (i - 1 + n) % n : e.key === 'Home' ? 0 : e.key === 'End' ? n - 1 : -1;
          if (j < 0) return;
          e.preventDefault(); setTab(tabs[j].getAttribute('data-ic-charts-tab'), true);
        });
      });
      var f = parseQ(st.q);
      if (f && f.pair) setSort('match');
      setTab(st.tab, false);
    }

    core.load(root.getAttribute('data-ref-url')).then(function () {
      boot();
      return core.loadIndex(root.getAttribute('data-index-url'));
    }).then(function () {
      listedEl.disabled = !core.indexed;
      if (server.as568 && core.indexed) {
        core.rows.as568.forEach(function (r) {
          var tr = server.as568[r.raw]; if (!tr) return;
          var n = core.listedCount(r.id, r.cs), a = tr.lastElementChild.querySelector('a');
          if (a && n && a.textContent !== n + ' grades') { a.className = 'ic-charts-cat'; a.textContent = n + ' grade' + (n === 1 ? '' : 's'); a.href = finderUrl(r); }
          if (a && !n && a.className.indexOf('--rfq') < 0) { a.className = 'ic-charts-cat ic-charts-cat--rfq'; a.textContent = 'Request'; a.href = rfqUrl(r); }
        });
      }
      paint(false);
    }).catch(function () {
      countEl.textContent = 'The size reference could not load. The AS568 chart above still works; for other systems use the size finder.';
    });
  }

  function init() { attach(); var el = document.querySelector('[data-ic-charts]'); if (el && !el.hasAttribute('data-ic-ready')) { el.setAttribute('data-ic-ready', ''); initCharts(el); } }
  if (window.OXXIC) init(); else document.addEventListener('DOMContentLoaded', init);
})();
